import { Component, OnInit } from '@angular/core';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.scss'],
})
export class InitialComponent implements OnInit {
  token: string = '';
  wealthName = '';

  constructor() {}

  ngOnInit(): void {
    this.removeCookies()
    this.token = getCookie('token');
    this.checkToken();
    this.wealthName = getCookie('wealthName');
  }

  checkToken(): void {
    if (!this.token) {
      window.location.href = 'https://app.techfinance.com.br';
    }
  }

  private removeCookies() {
    document.cookie =
      'formsId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
    document.cookie =
      'studyId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
    console.log('Cookies apagados');
  }
}
